import { getLocale } from './locale'

const browserLocale = getLocale()

const numberIntl = Intl.NumberFormat(browserLocale)

export const formatNumber = numberIntl.format
